import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import DteInvalidationLogHistory from "../../components/Hacienda/Invalidation/Log/DteInvalidationLogHistory";

/**
 * 📛 DteInvalidationErrorsPage
 *
 * Página para visualizar los errores ocurridos
 * durante el proceso de invalidación de DTE.
 */
const DteInvalidationErrorsPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <DteInvalidationLogHistory/>
    </DefaultLayout>
  );
};

export default DteInvalidationErrorsPage;
